<template lang="pug">
    div
        label.typo__label.multiselect-label(v-if="title !== null") {{ title }}
        multiselect(
            :ref="name",
            :value="value",
            label="name",
            track-by="id",
            :placeholder="placeholder",
            :options="options",
            :multiple="multiple",
            :close-on-select="closeOnSelect",
            :limit="20",
            :max-height="170",
            :disabled="displayForm",
            :hide-selected="hideSelected",
            :taggable="true",
            :loading="loading"
            :tag-placeholder="itemPlaceholder",
            @tag="addItem",
            @search-change="onSearchChange"
            @input="onChange"
        )
            template(slot="option", slot-scope="props")
                slot(name="option" v-bind:props="props")
                    span {{ props.option.name }}

            div(slot="selection" slot-scope="s")
                .multiselect__tags-wrap(v-show="s.values.length > 0 || fixedItems.length > 0")
                    span.multiselect__tag.fixed(v-for="f in fixedItems")
                        span {{ f }}

                    template(v-for="(option, index) of s.values" @mousedown.prevent="")
                        span.multiselect__tag(:key="index")
                            span(v-text="option.name")
                            i.multiselect__tag-icon(
                                aria-hidden="true"
                                tabindex="1"
                                @keydown.enter.prevent="s.remove(option)"
                                @mousedown.prevent="s.remove(option)")

            span(slot="placeholder" slot-scope="p" v-if="!fixedItems.length") {{ placeholder }}

        div.multiselect-form.m-b-lg(v-show="displayForm", v-click-outside="", :class="[name]")
            div.multiselect-form-header.dker
                i.text-muted.material-icons.md-18.pointer.pull-right(
                    @click="hideForm"
                ) &#xe14c;
                span._500.text-dark {{ formTitle }}

            div.multiselect-form-body
                slot(name="body")

            div.multiselect-form-footer.b-t
                button.btn.btn-outline.btn-sm.b-success.text-success(
                    type="button",
                    @click="create",
                    :disabled="onCreateLoading"
                ) Create

                button.btn.btn-sm.white.pull-right(
                    type="button",
                    @click="hideForm",
                    :disabled="onCreateLoading"
                ) Cancel
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    directives: {
        clickOutside: {
            bind(el, bindings, vnode) {
                document.addEventListener('click', e => {
                    const vm = vnode.context;
                    const isClickedOutside =
                        $(e.target).parents(`.${vm.name}`).length < 1;

                    if (isClickedOutside) {
                        if (vm.displayForm) {
                            vm.hideForm(false);
                        }
                    }
                });
            },
        },
    },
    props: {
        // eslint-disable-next-line vue/require-prop-types
        value: {
            required: true,
        },

        name: {
            type: String,
            required: true,
        },

        options: {
            type: Array,
            required: true,
        },

        placeholder: {
            type: String,
            default: 'Select or add item',
        },

        itemPlaceholder: {
            type: String,
            default: 'Add this as new item',
        },

        title: {
            type: String,
            default: null,
        },

        formTitle: {
            type: String,
            required: true,
        },

        loaderName: {
            type: String,
            default: 'create item',
        },

        multiple: {
            type: Boolean,
            default: true,
        },

        closeOnSelect: {
            type: Boolean,
            default: false,
        },

        hideSelected: {
            type: Boolean,
            default: true,
        },

        loading: {
            type: Boolean,
            default: false,
        },

        fixedItems: {
            type: Array,
            required: false,
            default: () => [],
        },
    },

    data() {
        return {
            displayForm: false,
        };
    },

    computed: {
        onCreateLoading() {
            return this.onLoading(this.loaderName);
        },
    },

    created() {
        this.validateValueProp();
    },

    mounted() {
        this.$on('item-created', item => {
            this.endLoading(this.loaderName);
            this.hideForm();

            setTimeout(() => {
                this.$refs[this.name].select(item);
            }, 100);
        });
    },

    methods: {
        hideForm(showOptions = true) {
            if (this.onLoading(this.loaderName)) return;

            this.displayForm = false;
            this.$emit('hide-form');

            if (this.showOptions) {
                this.showOptionList();
            }
        },

        showForm() {
            this.displayForm = true;
            this.$emit('show-form');
        },

        create() {
            this.$emit('create');
        },

        addItem(item) {
            this.$emit('add-item', item);
            this.showForm();
        },

        showOptionList() {
            setTimeout(() => {
                this.$refs[this.name].activate();
            }, 100);
        },

        onChange(value) {
            this.$emit('input', value);
        },

        validateValueProp() {
            const value = this.value;

            if (this.multiple) {
                if (!Array.isArray(value)) {
                    throw `Invalid property type of v-model. Expected array, got ${typeof value}`;
                }
            } else {
                // array will return as typeof object as well
                if (typeof value !== 'object' || Array.isArray(value)) {
                    throw 'Invalid property type of v-model. Expected Object';
                }
            }
        },

        onSearchChange(e) {
            this.$emit('search-change', e);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/item/multiselect-form.vue